/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Reveal_Sharesecurely3Inputs */

const en_settings_reportingapikeys_reveal_sharesecurely3 = /** @type {(inputs: Settings_Reportingapikeys_Reveal_Sharesecurely3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share this key with the client through a secure channel only (e.g. a password manager share or an expiring one-time link). Never send API keys via plain email or chat.`)
};

/**
* | output |
* | --- |
* | "Share this key with the client through a secure channel only (e.g. a password manager share or an expiring one-time link). Never send API keys via plain emai..." |
*
* @param {Settings_Reportingapikeys_Reveal_Sharesecurely3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_reveal_sharesecurely3 = /** @type {((inputs?: Settings_Reportingapikeys_Reveal_Sharesecurely3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Reveal_Sharesecurely3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_reveal_sharesecurely3(inputs)
});
export { settings_reportingapikeys_reveal_sharesecurely3 as "settings_reportingApiKeys_reveal_shareSecurely" }